import { render, staticRenderFns } from "./SurveyComponent.vue?vue&type=template&id=54feb14a"
import script from "./SurveyComponent.vue?vue&type=script&lang=js"
export * from "./SurveyComponent.vue?vue&type=script&lang=js"
import style0 from "./SurveyComponent.vue?vue&type=style&index=0&id=54feb14a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports